// src/services/notificheApi.js
import axiosInstance from './axiosInstance';

export const getNotifiche = () =>
    axiosInstance.get('/notifiche').then(r => r.data);

export const leggiNotifica = (id) =>
    axiosInstance.put(`/notifiche/${id}/leggi`).then(r => r.data);

export const leggiTutte = () =>
    axiosInstance.put('/notifiche/segna-tutte-lette').then(r => r.data);